import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
var CacheMechanism = /*#__PURE__*/function (CacheMechanism) {
  CacheMechanism.LocalStorage = 'LocalStorage';
  CacheMechanism.Cookie = 'Cookie';
  return CacheMechanism;
}(CacheMechanism || {});
const CACHE_NAME = new InjectionToken('CACHE_NAME');
const CACHE_MECHANISM = new InjectionToken('CACHE_MECHANISM');
const COOKIE_EXPIRY = new InjectionToken('COOKIE_EXPIRY');
const COOKIE_ATTRIBUTES = new InjectionToken('COOKIE_ATTRIBUTES');
const DEFAULT_CACHE_NAME = 'lang';
const DEFAULT_CACHE_MECHANISM = CacheMechanism.LocalStorage;
const DEFAULT_COOKIE_EXPIRY = 720;
let TranslateCacheSettings = /*#__PURE__*/(() => {
  class TranslateCacheSettings {
    constructor(cacheName = DEFAULT_CACHE_NAME, cacheMechanism = DEFAULT_CACHE_MECHANISM, cookieExpiry = DEFAULT_COOKIE_EXPIRY, cookieAttributes) {
      this.cacheName = cacheName;
      this.cacheMechanism = cacheMechanism;
      this.cookieExpiry = cookieExpiry;
      this.cookieAttributes = cookieAttributes;
    }
    static {
      this.ɵfac = function TranslateCacheSettings_Factory(t) {
        return new (t || TranslateCacheSettings)(i0.ɵɵinject(CACHE_NAME), i0.ɵɵinject(CACHE_MECHANISM), i0.ɵɵinject(COOKIE_EXPIRY), i0.ɵɵinject(COOKIE_ATTRIBUTES));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TranslateCacheSettings,
        factory: TranslateCacheSettings.ɵfac
      });
    }
  }
  return TranslateCacheSettings;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/* Not injectable */
class TranslateCacheService {
  constructor(translateService, translateCacheSettings) {
    this.translateService = translateService;
    this.translateCacheSettings = translateCacheSettings;
  }
  init() {
    this.translateService.onLangChange.subscribe(event => {
      if (this.translateCacheSettings.cacheMechanism === CacheMechanism.LocalStorage) {
        return this.cacheWithLocalStorage(event.lang);
      }
      if (this.translateCacheSettings.cacheMechanism === CacheMechanism.Cookie) {
        return this.cacheWithCookies(event.lang);
      }
    });
    const currentLang = this.getCachedLanguage() || this.translateService.getBrowserLang();
    if (currentLang) {
      this.translateService.use(currentLang);
    }
  }
  getCachedLanguage() {
    if (this.translateCacheSettings.cacheMechanism === CacheMechanism.LocalStorage) {
      return this.cacheWithLocalStorage();
    }
    if (this.translateCacheSettings.cacheMechanism === CacheMechanism.Cookie) {
      return this.cacheWithCookies();
    }
  }
  cacheWithLocalStorage(value) {
    if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
      return;
    }
    try {
      if (value) {
        window.localStorage.setItem(this.translateCacheSettings.cacheName, value);
        return;
      }
      return window.localStorage.getItem(this.translateCacheSettings.cacheName);
    } catch (e) {
      return;
    }
  }
  cacheWithCookies(value) {
    if (typeof document === 'undefined' || typeof document.cookie === 'undefined') {
      return;
    }
    try {
      const name = encodeURIComponent(this.translateCacheSettings.cacheName);
      if (value) {
        let cookieString = `${name}=${encodeURIComponent(value)}`;
        if (this.translateCacheSettings.cookieExpiry >= 0) {
          const date = new Date();
          date.setTime(date.getTime() + this.translateCacheSettings.cookieExpiry * 3600000);
          cookieString += `;expires=${date.toUTCString()}`;
        }
        if (this.translateCacheSettings.cookieAttributes) {
          cookieString += ';' + this.translateCacheSettings.cookieAttributes;
        }
        document.cookie = cookieString;
        return;
      }
      const regexp = new RegExp('(?:^' + name + '|;\\s*' + name + ')=(.*?)(?:;|$)', 'g');
      const result = regexp.exec(document.cookie);
      return decodeURIComponent(result[1]);
    } catch (e) {
      return;
    }
  }
}
let TranslateCacheModule = /*#__PURE__*/(() => {
  class TranslateCacheModule {
    static forRoot(config) {
      return {
        ngModule: TranslateCacheModule,
        providers: [{
          provide: CACHE_NAME,
          useValue: config.cacheName
        }, {
          provide: CACHE_MECHANISM,
          useValue: config.cacheMechanism
        }, {
          provide: COOKIE_EXPIRY,
          useValue: config.cookieExpiry
        }, {
          provide: COOKIE_ATTRIBUTES,
          useValue: config.cookieAttributes
        }, TranslateCacheSettings, config.cacheService]
      };
    }
    static {
      this.ɵfac = function TranslateCacheModule_Factory(t) {
        return new (t || TranslateCacheModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TranslateCacheModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return TranslateCacheModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-translate-cache
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CACHE_MECHANISM, CACHE_NAME, COOKIE_ATTRIBUTES, COOKIE_EXPIRY, CacheMechanism, TranslateCacheModule, TranslateCacheService, TranslateCacheSettings };
